import { takeEvery, call, put } from "redux-saga/effects";
import { trigger } from "swr";
import { loadCookies } from "./cookies";
import { SetWinningLimits, UseWinningLimits } from "../react/api/user/Limits.api";
import { UseUserMessages, UseMessagesUnreadCount } from "../react/api/user/Messages.api";
import { loadIncomingInbox, setWinLimit } from "./user";

export const SWR_REVALIDATE = "swr/revalidate";
export const LOAD_COOKIES = "LOAD_COOKIES";
export const LOAD_WINNING_LIMITS = "LOAD_WINNING_LIMITS";
export const SET_WINNING_LIMITS = "SET_WINNING_LIMITS";
export const GET_INCOMING_INBOX = "GET_INCOMING_INBOX";

function* swrTriggerRevalidate({ payload }) {
  yield call(trigger, payload, true);
}

function* loadCookiesSuccess({ payload }) {
  if (payload && payload.options) {
    yield put(loadCookies(payload));
  }
}

function* loadWinningLimit({ payload }) {
  const { card, token, language } = payload;
  if (card) {
    try {
      const { data } = yield call(UseWinningLimits, { card, token, language });
      const value = data && data.soglia_vinc ? Number(data.soglia_vinc) / 100 : "";
      yield put(setWinLimit({ value, response: null, error: null }));
    } catch {
      yield put(setWinLimit({ value: null, response: null, error: null }));
    }
  }
}

function* setWinSagaLimit({ payload }) {
  const { card, token, language, amount } = payload;

  if (card) {
    try {
      yield call(SetWinningLimits, { card, token, language, amount });
      const value = amount ? Number(amount) / 100 : null;
      const responseLabel = `private.profile.limits.new_limits.label_generic`;
      value ? yield put(setWinLimit({ value, response: responseLabel, error: null })) : null;
    } catch (error) {
      error ? yield put(setWinLimit({ value: Number(amount) / 100, response: null, error: error.message })) : null;
    }
  }
}

function* getIncomingInbox({ payload }) {
  const {card, csmf, token } = payload;
  let resp;
  try {
    resp = yield call(UseMessagesUnreadCount, "de", card, token, 0, null, csmf);
    const newMessages = resp?.data || 0;
    yield put(loadIncomingInbox(newMessages));
  } catch (error) {}
}

export default function* rootSaga() {
  yield takeEvery(SWR_REVALIDATE, swrTriggerRevalidate);
  yield takeEvery(LOAD_COOKIES, loadCookiesSuccess);
  yield takeEvery(LOAD_WINNING_LIMITS, loadWinningLimit);
  yield takeEvery(SET_WINNING_LIMITS, setWinSagaLimit);
  yield takeEvery(GET_INCOMING_INBOX, getIncomingInbox);
}
